import angular from 'angular';
const ngRoute = require('angular-route');
import routing from './terms.routes';
var localisations = require('./terms.localisations');

export class TermsController {
  constructor($http, $scope, socket, common, $timeout) {
    'ngInject';
    this.$http = $http;
    this.socket = socket;
    this.$timeout = $timeout;
    this.common = common;
    this.common.setPageTitle('');
    this.localisations = localisations[this.common.getLocale()];
    this.isAbout = false;
  }

  showAbout() {
    this.isAbout = !this.isAbout;
    this.$timeout(function(){
      window.scrollTo(0,0);
    }, 150)
  }
}

export default angular.module('ffApp.terms', [ngRoute])
  .config(routing)
  .component('terms', {
    template: require('./terms.html'),
    controller: TermsController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/terms/terms.component.js